import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { SelfhelpVideos } from "../help_support/components/SelfhelpVideos";
import rightArrow from "../../../assets/VZY/right-arrow.png";
import { InnerSearch } from "../components/search/InnerSearch";
import { HelpFilter } from "../components/HelpFilter/HelpFilter";

const INNER_SEARCH = {
  pageName: "Video Tutorials",
  breadcrumb: [
    {
      label: "Home",
      url: "/VZYSupport/helpSupport",
    },
    { label: "All Videos" },
  ],
};

const PAGE_SIZE = 12;

export const VideoList = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;

  const [selectedCategoryIDs, setSelectedCategoryIDs] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchSelfHelpVideoList = useCallback(
    async (page = 1, categoryIDs = selectedCategoryIDs) => {
      setLoading(true);
      setError("");

      try {
        const payload = {
          contentCode: "",
          contentTypeID: 2,
          categoryID: 0,
          isActive: 1,
          pageNumber: page,
          pageSize: PAGE_SIZE,
          searchValue: "",
          CategoryIDs: categoryIDs,
        };

        const response = await axios.post(
          `${apiBaseURL}/api/VZYHelpSupport/FetchRelatedVideo`,
          payload,
          { headers: { "Content-Type": "application/json" } },
        );

        const newData = response?.data?.result?.relatedVideos ?? [];

        setVideoList((prev) => (page === 1 ? newData : [...prev, ...newData]));

        setHasMore(newData.length === PAGE_SIZE);
      } catch (err) {
        console.error("FetchSelfHelpVideoList error:", err);
        setError("Failed to load videos. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [apiBaseURL, selectedCategoryIDs],
  );

  useEffect(() => {
    fetchSelfHelpVideoList(1);
  }, [fetchSelfHelpVideoList]);

  const handleLoadMore = () => {
    if (loading || !hasMore) return;

    const nextPage = pageNumber + 1;
    setPageNumber(nextPage);
    fetchSelfHelpVideoList(nextPage);
  };

  const handleApplyFilters = (ids) => {
    setSelectedCategoryIDs(ids);
    setPageNumber(1);
    setVideoList([]);
    setHasMore(true);
    fetchSelfHelpVideoList(1, ids);
  };

  return (
    <>
      <InnerSearch innerSearch={INNER_SEARCH} />

      <section className="vzy-common-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12 videos-tutorials-col">
              <HelpFilter
                filterIds="2"
                title="All Videos & Tutorials"
                onApplyFilters={handleApplyFilters}
              />
            </div>
          </div>

          <>
            {loading && pageNumber === 1 && (
              <p className="loaderVZY-data">Loading...</p>
            )}

            {error && <p className="error-text">{error}</p>}

            {/* {!loading && !error && videoList.length === 0 && (
                <p className="not-found-title">No videos found.</p>
              )} */}

            {videoList.length > 0 && (
              <div className="video-row">
                <SelfhelpVideos fetchHelpVideoList={videoList} />
              </div>
            )}

            {hasMore && !loading && videoList.length > 0 && (
              <button
                className="view-all-video-btn"
                onClick={handleLoadMore}
                type="button"
              >
                Load More &nbsp;
                <img src={rightArrow} alt="Load more" />
              </button>
            )}

            {loading && pageNumber > 1 && <p>Loading more videos...</p>}
          </>
        </div>
      </section>
    </>
  );
};
